import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

/**
 * Un item del sidebar.
 *
 * El estado activo se calcula de la ruta actual: antes no habia ninguna
 * senal de en que pagina estabas. El submenu se abre solo si una de sus
 * rutas es la activa, asi al recargar no queda cerrado escondiendo la
 * pagina en la que estas.
 *
 * El hover es CSS, no mutacion del DOM.
 */

// La ruta activa incluye las subrutas: /products/34/edit marca Products.
const rutaActiva = (pathname, to) => {
  if (!to) return false;
  const a = pathname.toLowerCase().replace(/\/+$/, "");
  const b = to.toLowerCase().replace(/\/+$/, "");
  return a === b || a.startsWith(b + "/");
};

function SidebarItem({ icon, label, to, children, collapsed, onNavigate }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const hijos = Array.isArray(children) ? children : [];
  const tieneHijos = hijos.length > 0;

  const hijoActivo = hijos.some((c) => rutaActiva(pathname, c.to));
  const activo = tieneHijos ? hijoActivo : rutaActiva(pathname, to);

  const [abierto, setAbierto] = useState(hijoActivo);

  // Si se navega a una subruta desde otro lado, el submenu se abre.
  useEffect(() => {
    if (hijoActivo) setAbierto(true);
  }, [hijoActivo]);

  const alClickear = () => {
    if (tieneHijos) {
      setAbierto((v) => !v);
      return;
    }
    if (to) {
      navigate(to);
      onNavigate?.();
    }
  };

  return (
    <div className="sbi">
      <button
        type="button"
        onClick={alClickear}
        className={`sbi-fila ${activo ? "sbi-fila--activo" : ""}`}
        // Con el sidebar colapsado el nombre no se ve: el title es la
        // unica forma de saber que es cada icono.
        title={collapsed ? label : undefined}
        aria-current={activo && !tieneHijos ? "page" : undefined}
        aria-expanded={tieneHijos ? abierto : undefined}
      >
        <span className="sbi-icono">{icon}</span>

        {!collapsed && <span className="sbi-texto">{label}</span>}

        {!collapsed && tieneHijos && (
          <span
            className={`sbi-chevron ${abierto ? "sbi-chevron--abierto" : ""}`}
            aria-hidden="true"
          >
            &#9656;
          </span>
        )}
      </button>

      {!collapsed && tieneHijos && abierto && (
        <div className="sbi-sub">
          {hijos.map((hijo) => {
            const subActivo = rutaActiva(pathname, hijo.to);
            return (
              <Link
                key={hijo.to}
                to={hijo.to}
                onClick={() => onNavigate?.()}
                className={`sbi-sub-item ${
                  subActivo ? "sbi-sub-item--activo" : ""
                }`}
                aria-current={subActivo ? "page" : undefined}
              >
                {hijo.label}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SidebarItem;
